﻿/**
 * Centralized Validation Utilities
 * Connect Source Architecture
 */

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// Standard international and Indian phone number formats
const PHONE_REGEX = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;

export interface ValidationResult {
  readonly isValid: boolean;
  readonly error?: string;
}

export function validateEmail(email: string): ValidationResult {
  if (!email || email.trim() === '') {
    return { isValid: false, error: 'Email address is required.' };
  }
  if (!EMAIL_REGEX.test(email.trim())) {
    return { isValid: false, error: 'Please provide a valid email address.' };
  }
  return { isValid: true };
}

export function validateName(name: string): ValidationResult {
  if (!name || name.trim().length < 2) {
    return { isValid: false, error: 'Name must be at least 2 characters.' };
  }
  if (name.length > 100) {
    return { isValid: false, error: 'Name cannot exceed 100 characters.' };
  }
  return { isValid: true };
}

export function validatePhone(phone: string): ValidationResult {
  if (!phone || phone.trim() === '') {
    return { isValid: true }; // Phone is optional in some lead flows
  }
  // Remove spaces, hyphens, and parentheses for length check
  const digitsOnly = phone.replace(/\D/g, '');
  if (digitsOnly.length < 10 || digitsOnly.length > 15) {
    return { isValid: false, error: 'Please provide a valid 10-15 digit phone number.' };
  }
  if (!PHONE_REGEX.test(phone.trim())) {
    return { isValid: false, error: 'Invalid phone format.' };
  }
  return { isValid: true };
}

export function validateDownloadTokenFormat(token: string): boolean {
  return typeof token === 'string' && token.startsWith('cst_') && token.length >= 16;
}

